module.exports = __webpack_public_path__ + "static/media/marker.596f9957.svg";